import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { Observable } from 'rxjs/Observable';
import { NzModalService } from 'ng-zorro-antd';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'app-find-psd',
    templateUrl: './find-psd.component.html',
    styleUrls: ['./find-psd.component.css']
})
export class FindPsdComponent implements OnInit {

    registerForm: FormGroup;
    modifyPsdForm: FormGroup;
    coding: number;
    isAcquire = false;
    companyInfo: any;

    constructor(
        private service: LoginService,
        private fb: FormBuilder,
        private services: LoginService,
        private modal: NzModalService,
        private translate: TranslateService,
        private router: Router
    ) { }

    ngOnInit() {
        this.service.getCompanyInfo().toPromise().then(x => {
            this.companyInfo = x[0];
        });

        this.registerForm = this.fb.group({
            email: [null, [Validators.required, this.checkEmail]],
            loginName: [null, [Validators.required], [this.checkUserName]]
        });
        this.modifyPsdForm = this.fb.group({
            code: [null, [Validators.required, this.checkCode]],
            password: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(16)]],
            checkPassword: [null, [Validators.required, this.confirmationValidator]]
        });
    }

    confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (control.value !== this.modifyPsdForm.controls['password'].value) {
            return { confirm: true, error: true };
        }
    }

    checkUserName = (control: FormControl): Observable<ValidationErrors> => {
        return this.services.checkUser({ loginName: control.value })
            .catch(error => Observable.of({ notExist: true }));
    }

    checkEmail(control: FormControl) {
        if (!control.value) {
            return { required: true };
        } else if (!/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/.test(control.value)) {
            return { error: true };
        }
    }

    checkCode(control: FormControl) {
        if (!control.value) {
            return { required: true };
        } else if (!/^\d{6}$/.test(control.value)) {
            return { error: true };
        }
    }

    getFormControl(name) {
        return this.modifyPsdForm.controls[name];
    }

    getregisterFormControl(name) {
        return this.registerForm.controls[name];
    }

    _submitModifyForm() {
        for (const i in this.registerForm.controls) {
            if (this.registerForm.controls.hasOwnProperty(i)) {
                this.registerForm.controls[i].markAsDirty();
            }
        }

        for (const i in this.modifyPsdForm.controls) {
            if (this.modifyPsdForm.controls.hasOwnProperty(i)) {
                this.modifyPsdForm.controls[i].markAsDirty();
            }
        }

        if (this.modifyPsdForm.valid && this.registerForm.valid) {
            const body = {
                loginName: this.registerForm.value.loginName,
                email: this.registerForm.value.email,
                password: this.modifyPsdForm.value.password,
                checkCode: this.modifyPsdForm.value.code
            };
            this.services.resetPsd(body).toPromise().then(res => {
                if (res) {
                    const modal = this.modal.success({
                        title: '密码设定成功'
                    });
                    setTimeout(() => {
                        modal.destroy();
                        this.router.navigate(['login']);
                    }, 2100);
                }
            }).catch(err => {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: err
                });
            });
        }
    }

    get isDisabled() {
        if (this.coding > 0) {
            return 'disabled';
        }
        return false;
    }

    acquireCode() {

        for (const i in this.registerForm.controls) {
            if (this.registerForm.controls.hasOwnProperty(i)) {
                this.registerForm.controls[i].markAsDirty();
            }
        }

        if (this.registerForm.valid) {

            const val = this.registerForm.value;
            const body = {
                loginName: val.loginName,
                email: val.email
            };
            this.services.acquiryCode(body).toPromise().then(res => {
                if (res) {
                    this.modal.warning({
                        title: this.translate.instant('common.warn'),
                        content: '验证码已发送至邮箱，请注意查收！'
                    });

                    Observable.interval(1000)
                        .take(60)
                        .map(x => 59 - x)
                        .subscribe(x => {
                            this.coding = x
                        });
                }
            }).catch(err => {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: err
                });
            });
        }
    }

    updateConfirmValidator() {
        /** wait for refresh value */
        setTimeout(() => {
            this.modifyPsdForm.controls['checkPassword'].updateValueAndValidity();
        });
    }

    enquiry() {
        this.router.navigate(['/price/enquiry-public'], {
            queryParams: { 'date': new Date().getTime() }
        });
    }

    get year() {
        return { year: moment().year() };
    }


    get website() {
        if (this.companyInfo) {
            if (_.startsWith(this.companyInfo.website, 'http://')) {
                return this.companyInfo.website;
            }
            return 'http://' + this.companyInfo.website;
        }
        return 'javascript://void(0);';
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/find-psd/find-psd.component.ts